import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import _ from 'lodash';

const PaginationPage = ({ pageNumbers, changePaginationIndex, currentPage, pageRange, showPaginnation }) => {
  const [start, setStart] = useState();
  const [end, setEnd] = useState();
  const numberOfRange = pageRange;
  useEffect(() => {
    if (pageNumbers < numberOfRange) {
      setStart(1);
      setEnd(pageNumbers + 1);
    } else {
      setStart(currentPage);
      if (currentPage + numberOfRange <= pageNumbers) setEnd(currentPage + numberOfRange);
      else setEnd(pageNumbers + 1);
    }
  }, [pageNumbers]);

  const handleClick = (index) => {
    if (index === 'next') {
      changePaginationIndex(currentPage + 1);
      if (currentPage + 1 > end - 1) {
        setStart(currentPage + 1);
        if (currentPage + numberOfRange < pageNumbers) setEnd(currentPage + numberOfRange + 1);
        else setEnd(pageNumbers + 1);
      }
    } else if (index === 'previous') {
      changePaginationIndex(currentPage - 1);
      if (currentPage - 1 < start && currentPage - 1 > 0) {
        setEnd(currentPage);
        if (currentPage - numberOfRange > 0) setStart(currentPage - numberOfRange);
        else setStart(1);
      }
    } else if (index === 'first') {
      if (start - numberOfRange > 0) {
        setStart(start - numberOfRange);
        setEnd(start);
        changePaginationIndex(currentPage - numberOfRange);
      }
    } else if (index === 'end') {
      if (end + numberOfRange < pageNumbers + 1) {
        setStart(start + numberOfRange);
        setEnd(end + numberOfRange);
        changePaginationIndex(currentPage + numberOfRange);
      }
    }
  };

  if (pageNumbers > 1 && showPaginnation === true) {
    return (
      <Pagination aria-label="Page navigation example" className="mb-3">
        <PaginationItem disabled={(start - numberOfRange < 0 && true) || false}>
          <PaginationLink onClick={() => handleClick('first')}>&lsaquo;</PaginationLink>
        </PaginationItem>
        <PaginationItem disabled={(currentPage === 1 && true) || false}>
          <PaginationLink previous onClick={() => handleClick('previous')} />
        </PaginationItem>
        {_.range(start, end).map((number) => (
          <PaginationItem key={number} className={currentPage === number ? 'active' : ''}>
            <PaginationLink onClick={() => changePaginationIndex(number)} data-cy="pagi">
              {number}
            </PaginationLink>
          </PaginationItem>
        ))}
        <PaginationItem disabled={(currentPage === pageNumbers && true) || false}>
          <PaginationLink next onClick={() => handleClick('next')} />
        </PaginationItem>
        <PaginationItem disabled={(end + numberOfRange > pageNumbers && true) || false}>
          <PaginationLink onClick={() => handleClick('end')}>&rsaquo;</PaginationLink>
        </PaginationItem>
      </Pagination>
    );
  }
  return null;
};

export default PaginationPage;

PaginationPage.propTypes = {
  currentPage: PropTypes.number,
  pageRange: PropTypes.number,
  pageNumbers: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]).isRequired,
  changePaginationIndex: PropTypes.func.isRequired,
  showPaginnation: PropTypes.bool,
};

PaginationPage.defaultProps = {
  currentPage: 1,
  showPaginnation: true,
  pageRange: 10,
};
